// src/components/SphereFlow.js
import React, { useState, useEffect } from 'react';
import ThreeSphere from '../AMyteSphere/ThreeSphere';
import SignupForm from './SignupForm';
import TextSequence from './TextSequence';

function SphereFlow() {
  const [stage, setStage] = useState('sphere'); // stages: 'sphere' → 'form' → 'text'

  // Preload assets in the background (audio and logo)
  useEffect(() => {
    const preloadAssets = () => {
      const audio = new Audio('/sounds/thump.mp3');
      audio.volume = 1.0;
      audio.load();
      const logo = new Image();
      logo.src = '/LogoFile.png';
    };
    preloadAssets();
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        minHeight: '100vh', // Changed from height to minHeight to allow expansion
        overflowY: 'auto', // Enable vertical scrolling
        position: 'relative',
        backgroundColor: '#000',
      }}
    >
      {stage === 'sphere' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh', // Sphere stays full-screen
          }}
        >
          <ThreeSphere onComplete={() => setStage('form')} />
        </div>
      )}
      {stage === 'form' && (
        <SignupForm onSuccess={() => setStage('text')} />
      )}
      {stage === 'text' && (
        <TextSequence
          onComplete={() => {
            window.location.href = 'https://mytegroup.ai';
          }}
        />
      )}
    </div>
  );
}

export default SphereFlow;